export const CabinClass = Object.freeze({
  TOURIST: 'TOURIST',
  PREMIUM_ECONOMY: 'PREMIUM_ECONOMY',
  BUSINESS: 'BUSINESS',
  FIRST: 'FIRST',
});

export const TripType = Object.freeze({
  ROUND_TRIP: 'roundTrip',
  ONE_WAY: 'oneWayTrip',
  MULTIPLE: 'multipleTrip',
});

export const carriersWithAlternative = ['FR', 'RK'];
